import { useRef } from "react";
import { TEXT } from "../../utils/ludDocuments.constants";
import "./UploadZone.css";

export default function UploadZone({
  label,
  icon,
  onFiles,
  disabled = false,
  busy = false,
  multiple = false,
  accept,
  lang = "ar",
}) {
  const ref = useRef();

  const handleFiles = (files) => {
    if (disabled) return;
    onFiles?.(files);
  };

  return (
    <button
      type="button"
      className={`lud-upload-zone ${disabled ? "is-disabled" : ""}`}
      disabled={disabled}
      aria-disabled={disabled}
      aria-busy={busy || undefined}
      onClick={() => {
        if (!disabled) {
          ref.current?.click();
        }
      }}
      onDragOver={(event) => {
        if (!disabled) {
          event.preventDefault();
        }
      }}
      onDrop={(event) => {
        if (disabled) return;

        event.preventDefault();
        handleFiles([...event.dataTransfer.files]);
      }}
    >
      {icon}

      <span>{label}</span>

      {disabled && !busy && (
        <small className="lud-upload-zone-note">
          {TEXT.uploadZoneDisabled[lang]}
        </small>
      )}

      <input
        ref={ref}
        type="file"
        hidden
        disabled={disabled}
        multiple={multiple}
        accept={accept}
        onChange={(event) => {
          handleFiles([...event.target.files]);
          event.target.value = "";
        }}
      />
    </button>
  );
}